// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"ad8f0ac5","359":"cc310ade","540":"87aebac0","740":"585e1933","825":"c348d15b","936":"f16222d0"}[chunkId] + ".chunk.css";
};